"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var select_url_variable_button_component_1 = __importDefault(require("../select-url-variable-button/select-url-variable-button.component"));

var delete_icon_button_component_1 = __importDefault(require("../../common-components/delete-icon-button/delete-icon-button.component"));

var set_action_url_button_styles_1 = require("./set-action-url-button.styles");

var SetActionUrlButton = function SetActionUrlButton(_ref) {
  var urlVariable = _ref.urlVariable,
      setActionUrl = _ref.setActionUrl,
      removeActionUrl = _ref.removeActionUrl;
  return React.createElement(set_action_url_button_styles_1.StyledSetActionUrlButtonWrapperDiv, null, React.createElement(select_url_variable_button_component_1.default, {
    urlVariable: urlVariable,
    onUrlVariableSelect: function onUrlVariableSelect(variable) {
      return setActionUrl("${".concat(variable.key, "}"));
    }
  }), React.createElement(delete_icon_button_component_1.default, {
    onClick: removeActionUrl
  }));
};

exports.default = SetActionUrlButton;